export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["재활용 캠페인 검색"])}
    }
  })
}
